import Http from 'axios'
import {
    API_URL, API_VERSION,
    VERSION
} from '../../../config/config'

import {buildFormData} from "../../../helpers/FormdData";

const single_traveller_information = {
    visa_number: "",
    passport_number: "",
    dob: "",
    country_id: '',
    full_name: '',
    occupation: '',
    contact_no: '',
    email: null,
    user_image: null,
    passport: {
        passport_image: {},
    },
    recommendation_letter: null
};

function initialState() {
    return {
        trekkingData: {
            recommendation_letter: {},
            trekkers: {},
        },
        loading: false,
        trekkingRequestDetails: [],
        countries: [],
        travellers: [single_traveller_information],
    }
}

const getters = {
    loading: state => state.loading,
    trekkingData: state => state.trekkingData,
    trekkers: state => state.travellers,
    trekkingRequestDetails: state => state.trekkingRequestDetails,
    trekkingAgencyData: state => state.trekkingAgencyData,
    countries: state => state.countries,
};

const actions = {
    createSingleTrekkingRequest({
                                    commit,
                                    state
                                }) {
        commit('setLoading', true);
        let formData = new FormData();
        console.log(state.travellers);
        for (let i = 0; i < state.travellers.length; i++) {
            const trekker = state.travellers[i];
            formData.append(`trekkers[${i}][indian_without_visa]`, trekker.indian_without_visa ? trekker.indian_without_visa : 0);
            if (trekker.indian_without_visa){
                formData.append(`trekkers[${i}][country_id]`, 236);
            }
            else {
                formData.append(`trekkers[${i}][country_id]`, trekker.country_id);
            }
            formData.append(`trekkers[${i}][dob]`, trekker.dob);
            if (!!trekker.email) {
                formData.append(`trekkers[${i}][email]`, trekker.email);
            } else {
                formData.append(`trekkers[${i}][email]`, '');
            }
            formData.append(`trekkers[${i}][full_address]`, trekker.full_address);
            formData.append(`trekkers[${i}][contact_no]`, trekker.contact_no    );
            formData.append(`trekkers[${i}][full_name]`, trekker.full_name);
            formData.append(`trekkers[${i}][gender]`, trekker.gender);
            formData.append(`trekkers[${i}][occupation]`, trekker.occupation);
            formData.append(`trekkers[${i}][passport_number]`, trekker.passport_number);
            formData.append(`trekkers[${i}][passport_image]`, trekker.passport.passport_image);
            formData.append(`trekkers[${i}][passport_type]`, trekker.passport.passport_type);
            if (!!trekker.passport.validity) {
                formData.append(`trekkers[${i}][validity]`, trekker.passport.validity);
            } else {
                formData.append(`trekkers[${i}][validity]`, '');
            }
            formData.append(`trekkers[${i}][recommendation_letter]`, trekker.recommendation_letter);
            formData.append(`trekkers[${i}][user_image]`, trekker.user_image);


        }

        buildFormData(formData, state.trekkingData);

        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/single-trekking/permit/save', formData)
                .then(response => {
                    commit('setTrekkingRequestDetails', response.data);
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },


    async checkSingleVisaValidity({commit, state},data) {
        let errors = [];
        const trekkers = JSON.parse(JSON.stringify(state.travellers));
        const responses = await Promise.all(
            trekkers.map(async trekker => {
                try {
                    if (trekker.indian_without_visa) {
                        return true;
                    }
                    const response = await Http.get(`${API_URL}${VERSION}/visa-passport-validity?
                    passport_number=${trekker.passport_number}&visa_number=${trekker.visa_number}&last_date=${data.last_date}`);
                    commit('setSingleTravellerData', {
                        passport_number: trekker.passport_number,
                        visa_number: trekker.visa_number,
                        dob: trekker.dob,
                        ...response.data.data
                    });
                    return {found: true};
                } catch (e) {
                    return {found: false, errors: e.response.data.message};
                }
            })
        );
        for (let i = 0; i < responses.length; i++) {
            if (responses[i].found === false) {
                errors.push(responses[i].errors);
            }
        }
        return errors;
    },
    updatePaymentStatus({
                            commit,
                            state
                        }, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekkings/update-payment-status', data)
                .then(response => {
                    commit('setLoading', false);
                    commit('setTrekkinData', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    resetTrekRequestState({
                              commit
                          }) {
        commit('resetState')
    },
    getCountries({commit}) {
        Http.get(API_URL + API_VERSION + "/countries-for-tourist-visa")
            .then(response => {
                commit('setCountries', response.data.data);
            })
    }
}

const mutations = {
    setTrekkingAgencyData(state, items) {
        state.trekkingAgencyData = items
    },

    setSingleTravellerData(state, item) {
        state.trekkingData.trekkers = state.travellers.map((trekker) => {
            if (trekker.passport_number === item.passport_number && trekker.visa_number === item.visa_number) {
                trekker.name = item.name;
                trekker.full_name = item.name;
                trekker.country = item.country;
                trekker.dob = item.dob;
            }
            console.log(trekker)
            return trekker;
        });
    },
    setTrekkinData(state, items) {
        state.trekkingData = items
    },
    setTravellerData(state, items) {
        state.travellerData = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setTrekkingRequestDetails(state, trekkingRequestDetails) {
        state.trekkingRequestDetails = trekkingRequestDetails
    },
    resetState(state) {
        state = Object.assign(state, initialState());
        state.trekkingData.starting_date = '';
    },
    addTraveller(state) {
        state.travellers.push({
            visa_number: "",
            passport_number: "",
            dob: "",
            country_id: '',
            full_name: '',
            occupation: '',
            contact_no: '',
            email: null,
            user_image: null,
            passport: {
                passport_image: {},
            },
            recommendation_letter: null
        })
    },
    removeTraveller(state, index) {
        state.travellers.splice(index, 1)
    },
    setCountries(state, country) {
        state.countries = country;
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
